<template>
	<order-info></order-info>
</template>

<script>
import OrderInfo from "@/components/shop/order/orderInfo";
export default {
	name: "order_Info",
	components: {OrderInfo}
}
</script>

<style scoped>

</style>